// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CloudIpResourceKindSchema = z.enum(['elastic_ip','eni_public','public_ip','prefix','byoip','lb_frontend','nat','dns_origin'] as const);

export type CloudIpResourceKindType = `${z.infer<typeof CloudIpResourceKindSchema>}`

export default CloudIpResourceKindSchema;
